import { I18n } from '@/services/i18n';

type Message = {
  sub1: string;
  text1: string;
  sub2: string;
  text2: string;
  sub3: string;
  text3: string;
  sub4: string;
  text4: string;
  sub5: string;
  text5: string;
  sub6: string;
  text6: string;
  sub7: string;
  text7: string;
  sub8: string;
  text8: string;
  sub9: string;
  text9: string;
  text10: string;

  sub11: string;
  text11: string;

  sub12: string;
  text12: string;

  premiumFiltersTitle: string;
  premiumFiltersDescription: string;
};

const messages: I18n<Message> = {
  en: {
    sub1: 'Advanced information',
    text1: 'See all photos and full <br />profiles of other singles',
    sub2: 'Unlimited Likes',
    text2: 'Now you can send only <br />{likeCount}&nbsp;likes daily',
    sub3: 'Advanced filters',
    text3: 'Use unlimited filters to find <br />your type of person',
    sub4: 'Unlimited chatting',
    text4: 'No limits on chatting and <br />messaging',
    sub5: 'See who likes you',
    text5: 'Your Activity is blurred, unlock <br />it to meet everyone',
    sub6: 'Boost your profile',
    text6: 'Boost your profile and get X5 <br />visits and X2 likes',
    sub7: 'No Ads',
    text7: 'Tired of ads? Upgrade and <br />don’t get bothered by <br />advertising',
    sub8: 'Unlock location',
    text8: "You can't see the location <br />on profiles right now",
    sub9: 'Access to all profiles',
    text9: 'Now, you can see only 20<br />singles nearby',
    text10: 'Boost your profile and attract <br /> more attention',
    premiumFiltersTitle: 'Premium Filters',
    premiumFiltersDescription:
      'Find matches near you, with the<br /> same goal, in another city, or online!',

    sub11: 'Unlimited Rewinds',
    text11: 'Go back and try again!',

    sub12: 'See more Soulmates',
    text12: 'Your most compatible matches,<br /> updated daily.',
  },
  es: {
    sub1: 'Información avanzada',
    text1: 'Ver todas las fotos y perfiles <br />completos de otros solteros',
    sub2: 'Likes ilimitados',
    text2: 'Ahora solo puedes enviar <br />{likeCount} likes al día',
    sub3: 'Filtros avanzados',
    text3: 'Usa filtros ilimitados para <br />encontrar tu tipo de persona',
    sub4: 'Chat ilimitado',
    text4: 'Sin límites en el chat y <br />mensajería',
    sub5: 'Ver quién te gusta',
    text5: 'Tu actividad está borrosa, <br />desbloquéala para conocer a <br />todos',
    sub6: 'Impulsa tu perfil',
    text6: 'Impulsa tu perfil y obtén X5 <br />visitas y X2 likes',
    sub7: 'Sin anuncios',
    text7: '¿Cansado de los anuncios? <br />Actualiza y no te molestes <br />con la publicidad',
    sub8: 'Desbloquear ubicación',
    text8: 'No puedes ver la ubicación <br />en los perfiles en este momento',
    sub9: 'Acceso a todos los perfiles',
    text9: 'Ahora, puedes ver solo 20 <br />solteros cerca',
    text10: 'Impulsa tu perfil y atrae <br />más atención',
    premiumFiltersTitle: 'Filtros Premium',
    premiumFiltersDescription:
      '¡Encuentra parejas cerca de ti, con el<br /> mismo objetivo, en otra ciudad o en línea!',

    sub11: 'Rewind ilimitado',
    text11: 'Ahora puedes deshacerte de la última <br />acción y volver a intentarlo!',

    sub12: 'Ver más Soulmates',
    text12: 'Tus parejas más compatibles,<br /> actualizadas diariamente.',
  },
  de: {
    sub1: 'Erweiterte Informationen',
    text1: 'Sehen Sie alle Fotos und vollständige <br />Profile anderer Singles',
    sub2: 'Unbegrenzte Likes',
    text2: 'Jetzt können Sie nur <br />{likeCount}&nbsp;Likes täglich senden',
    sub3: 'Erweiterte Filter',
    text3: 'Verwenden Sie unbegrenzte Filter, um <br />Ihren Typ von Person zu finden',
    sub4: 'Unbegrenztes Chatten',
    text4: 'Keine Begrenzungen beim Chatten und <br />Nachrichten',
    sub5: 'Sehen Sie, wer Sie mag',
    text5: 'Ihre Aktivität ist verschwommen, entsperren <br />Sie sie, um alle zu treffen',
    sub6: 'Boost dein Profil',
    text6: 'Steigern Sie Ihr Profil und erhalten Sie X5 <br />Besuche und X2 Likes',
    sub7: 'Keine Anzeigen',
    text7: 'Genervt von Anzeigen? Upgrade und <br />lassen Sie sich nicht von <br />Werbung stören',
    sub8: 'Standort entsperren',
    text8: 'Sie können den Standort <br />in Profilen derzeit nicht sehen',
    sub9: 'Zugang zu allen Profilen',
    text9: 'Jetzt kannst du nur 20 <br />Singles in der Nahe sehen',
    text10: 'Boost dein Profil und attrahiere <br />mehr Aufmerksamkeit',
    premiumFiltersTitle: 'Premium-Filter',
    premiumFiltersDescription:
      'Finden Sie Übereinstimmungen in Ihrer Nähe, mit <br />dem gleichen Ziel, in einer anderen Stadt oder online!',

    sub11: 'Unbegrenzte Rewinds',
    text11: 'Jetzt kannst du die letzte <br />Aktion rückgängig machen!',

    sub12: 'Unbegrenzte Soulmates',
    text12:
      'Finden Sie Übereinstimmungen in Ihrer Nähe, mit <br />dem gleichen Ziel, in einer anderen Stadt oder online!',
  },
};

export { messages };
